import React from 'react'
import css from './textarea.css'

type Props = {
  label?: string
  name?: string
  value?: string
  rows?: string | number
  placeholder?: string
  onChange?: (...args: Array<any>) => any
}

const Textarea = ({ label, ...inputProps }: Props & React.HTMLProps<HTMLTextAreaElement>) => (
  <div className={css.component}>
    <label>
      {label && <p className={css.label}>{label}</p>}
      <textarea {...inputProps} />
    </label>
  </div>
)

export default Textarea
